<template>
<v-snackbar
    v-model="showSnackBar"
    :timeout="timeout"
    :color="color"
    >
    {{ message }}

    <template v-slot:action="{ attrs }">
        <v-btn
        :color="closeTextColor"
        text
        v-bind="attrs"
        @click="showSnackBar = false"
        >
        Close
        </v-btn>
    </template>
</v-snackbar>
</template>

<script>
export default {
  props: [
    'message',
    'color',
    'closeTextColor',
    'timeout'
  ],
  data () {
    return {
      showSnackBar: false
    }
  },
  computed: {
    timeoutValue () {
      return this.timeout || 3000
    }
  },
  methods: {
    show () {
      this.showSnackBar = true
    }
  }
}
</script>
